import React from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
} from 'reactflow';
import type { PeopleTravelLeg, PeopleTravelLegMode, PeopleTravelOption } from '../../../../types';
import { LEG_MODE_LABELS } from '../../../../utils/peopleTravelCanvasGraph';

export type TravelLegData = {
  leg: PeopleTravelLeg;
  fromLabel: string;
  toLabel: string;
  options: PeopleTravelOption[];
  readOnly?: boolean;
  onModeChange?: (legId: string, mode: PeopleTravelLegMode) => void;
};

const MODES: PeopleTravelLegMode[] = ['flight', 'drive', 'rental_car', 'other'];

const TravelLegEdge: React.FC<EdgeProps<TravelLegData>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  selected,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });
  const leg = data?.leg;
  const options = data?.options || [];

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: selected ? '#2d6a4f' : '#8a8074',
          strokeWidth: selected ? 3 : 2,
        }}
      />
      <EdgeLabelRenderer>
        <div
          className="people-travel-leg-label nodrag nopan"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
          }}
        >
          {leg && (
            <select
              className="people-travel-leg-mode"
              value={leg.mode}
              disabled={data?.readOnly}
              onChange={e => data?.onModeChange?.(leg.id, e.target.value as PeopleTravelLegMode)}
            >
              {MODES.map(mode => (
                <option key={mode} value={mode}>
                  {LEG_MODE_LABELS[mode]}
                </option>
              ))}
            </select>
          )}
          {options.length > 0 && (
            <div className="people-travel-leg-chips">
              {options.slice(0, 3).map(opt => (
                <span key={opt.id} className="people-travel-leg-chip">
                  {opt.vendor || opt.label}
                  {opt.price ? ` · $${opt.price}` : ''}
                </span>
              ))}
            </div>
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default React.memo(TravelLegEdge);
